import React from 'react';

// ============================================================
// Unified Panel Styles - Shared across all extracted components
// ============================================================

// Main Layout Container Styles (used by SidebarLayout)
export const mainControlContainerStyle: React.CSSProperties = {
    position: 'fixed',
    bottom: '20px',
    left: '20px',
    zIndex: 1300,
    display: 'flex',
    alignItems: 'flex-end', // Keep button anchored at bottom when menu opens
};

export const mainToggleStyle: React.CSSProperties = {
    background: 'rgba(20, 20, 20, 0.95)',
    border: '2px solid #4fc3f7',
    borderRadius: '50%',
    color: '#4fc3f7',
    cursor: 'pointer',
    padding: '12px',
    fontSize: '20px',
    width: '50px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 20px rgba(79, 195, 247, 0.3)',
    transition: 'all 0.2s ease',
    flexShrink: 0,
};

export const attachedMenuStyle: React.CSSProperties = {
    background: 'rgba(20, 20, 20, 0.95)',
    border: '1px solid #333',
    borderRadius: '8px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
    marginLeft: '10px',
    width: '400px',
    maxHeight: '80vh',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'monospace',
    color: '#eee',
    backdropFilter: 'blur(10px)',
    zIndex: 1400,
};

export const menuHeaderStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 16px',
    backgroundColor: 'rgba(30, 30, 30, 0.9)',
    borderBottom: '1px solid #333',
    borderRadius: '8px 8px 0 0',
    flexShrink: 0,
};

export const menuTitleStyle: React.CSSProperties = {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#4fc3f7',
};

export const menuCloseStyle: React.CSSProperties = {
    background: 'rgba(200, 60, 60, 0.8)',
    border: '1px solid #aa4444',
    color: '#fff',
    cursor: 'pointer',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '12px',
    transition: 'all 0.2s ease',
};

export const menuContentStyle: React.CSSProperties = {
    flex: 1,
    overflow: 'auto',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
};

// ============================================================
// Statistics Panel Styles
// ============================================================

export const unifiedStatsContainer: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
};

export const unifiedStatsItem: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '4px 0',
    borderBottom: '1px solid #333',
};

export const unifiedStatsLabel: React.CSSProperties = {
    fontSize: '11px',
    color: '#ccc',
    fontWeight: 'bold',
};

export const unifiedStatsValue: React.CSSProperties = {
    fontSize: '11px',
    color: '#4fc3f7',
    fontWeight: 'bold',
};

// ============================================================
// Species Panel Styles
// ============================================================

export const unifiedSpeciesContainer: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
};

export const unifiedSpeciesItem: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '4px 0',
};

export const unifiedSpeciesLeft: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flex: 1,
};

export const unifiedSpeciesRight: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
};

export const unifiedSpeciesButton: React.CSSProperties = {
    background: 'rgba(60, 60, 60, 0.8)',
    border: '1px solid #666',
    color: '#ccc',
    cursor: 'pointer',
    padding: '6px 8px',
    borderRadius: '4px',
    fontSize: '11px',
    transition: 'all 0.2s ease',
    flex: 1,
    marginRight: '8px',
    minHeight: '28px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'left',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    transform: 'scale(1)',
    boxShadow: 'none',
};

export const unifiedSpeciesButtonFocused: React.CSSProperties = {
    background: 'rgba(79, 195, 247, 0.3)',
    border: '2px solid #4fc3f7',
    color: '#4fc3f7',
    transform: 'scale(1.02)',
    boxShadow: '0 0 8px rgba(79, 195, 247, 0.5)',
};

export const unifiedSpeciesCount: React.CSSProperties = {
    fontSize: '10px',
    color: '#888',
    minWidth: '80px',
    textAlign: 'right',
    fontFamily: 'monospace',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};

// ============================================================
// Reactions Panel Styles
// ============================================================

export const unifiedReactionsContainer: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
};

export const unifiedReactionItem: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '4px 0',
};

export const unifiedReactionButton: React.CSSProperties = {
    background: 'rgba(60, 60, 60, 0.8)',
    border: '1px solid #666',
    color: '#ccc',
    cursor: 'pointer',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '10px',
    transition: 'all 0.2s ease',
    flex: 1,
    marginRight: '8px',
};

export const unifiedReactionButtonFocused: React.CSSProperties = {
    background: 'rgba(79, 195, 247, 0.3)',
    border: '2px solid #4fc3f7',
    color: '#4fc3f7',
    transform: 'scale(1.02)',
    boxShadow: '0 0 8px rgba(79, 195, 247, 0.5)',
};

export const unifiedReactionRate: React.CSSProperties = {
    fontSize: '10px',
    color: '#888',
    minWidth: '60px',
    textAlign: 'right',
};

// ============================================================
// Color Inheritance Indicator Styles
// ============================================================

export const inheritanceIndicator: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '10px',
    color: '#888'
};

export const inheritanceArrow: React.CSSProperties = {
    fontSize: '12px',
    color: '#4CAF50',
    fontWeight: 'bold'
};

export const inheritanceSource: React.CSSProperties = {
    fontSize: '10px',
    color: '#4CAF50',
    fontWeight: 'bold'
};

export const customIndicator: React.CSSProperties = {
    fontSize: '10px',
    color: '#FF9800',
    fontWeight: 'bold'
};

// ============================================================
// Control Panel Styles
// ============================================================

export const unifiedControlsContainer: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
};

export const unifiedControlGroup: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
};

export const unifiedControlButton: React.CSSProperties = {
    background: 'rgba(60, 150, 60, 0.8)',
    border: '1px solid #44aa44',
    color: '#fff',
    cursor: 'pointer',
    padding: '6px 12px',
    borderRadius: '4px',
    fontSize: '11px',
    fontWeight: 'bold',
    transition: 'all 0.2s ease',
};

export const unifiedControlButtonStart: React.CSSProperties = {
    background: 'rgba(60, 150, 60, 0.8)',
    border: '1px solid #44aa44',
};

export const unifiedControlButtonPause: React.CSSProperties = {
    background: 'rgba(255, 150, 0, 0.8)',
    border: '1px solid #ff8800',
};

export const unifiedControlButtonReset: React.CSSProperties = {
    background: 'rgba(200, 60, 60, 0.8)',
    border: '1px solid #aa4444',
    color: '#fff',
    cursor: 'pointer',
    padding: '6px 12px',
    borderRadius: '4px',
    fontSize: '11px',
    fontWeight: 'bold',
    transition: 'all 0.2s ease',
};

export const unifiedControlLabel: React.CSSProperties = {
    fontSize: '11px',
    color: '#ccc',
    fontWeight: 'bold',
};

export const unifiedControlSlider: React.CSSProperties = {
    width: '100%',
    height: '4px',
    background: 'rgba(60, 60, 60, 0.8)',
    outline: 'none',
    borderRadius: '2px',
    cursor: 'pointer',
};

export const unifiedControlToggleLabel: React.CSSProperties = {
    fontSize: '11px',
    color: '#ccc',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
};

export const unifiedControlCheckbox: React.CSSProperties = {
    width: '14px',
    height: '14px',
    cursor: 'pointer',
};

export const unifiedControlSection: React.CSSProperties = {
    marginBottom: '8px',
};

export const unifiedControlSectionHeader: React.CSSProperties = {
    width: '100%',
    padding: '6px 8px',
    background: 'rgba(40, 40, 40, 0.9)',
    border: '1px solid rgba(80, 80, 80, 0.8)',
    borderRadius: '4px',
    color: '#fff',
    fontSize: '11px',
    fontWeight: 'bold',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    transition: 'all 0.2s ease',
    outline: 'none',
};

export const unifiedControlSectionIcon: React.CSSProperties = {
    fontSize: '10px',
    color: '#888',
    width: '12px',
    textAlign: 'center',
};

export const unifiedControlSectionContent: React.CSSProperties = {
    padding: '8px 0 0 12px',
    borderLeft: '2px solid rgba(60, 60, 60, 0.6)',
    marginLeft: '6px',
};

export const unifiedControlSelect: React.CSSProperties = {
    width: '100%',
    padding: '4px 6px',
    background: 'rgba(60, 60, 60, 0.9)',
    border: '1px solid rgba(80, 80, 80, 0.8)',
    borderRadius: '3px',
    color: '#fff',
    fontSize: '11px',
    cursor: 'pointer',
};

export const unifiedControlColorPicker: React.CSSProperties = {
    width: '40px',
    height: '32px',
    padding: '0',
    background: 'transparent',
    border: '1px solid rgba(80, 80, 80, 0.8)',
    borderRadius: '4px',
    cursor: 'pointer',
    minWidth: '40px',
    minHeight: '32px',
};
